'use strict'

resizeFlg = {}
resizeFlg.pc = true
resizeFlg.sp = true
firstView = ''

clinicSlide = ()->
  console.log('flux:PC')
  $contentsSlide = $('.p-clinic-summary .js-flux-slide')

  slideFlg = false
  offset = 100

  if window.clinicFlux is undefined
    window.clinicFlux = new flux.slider($contentsSlide, {
      autoplay: false,
      pagination: false,
      transitions: ['blocks2'],
      delay: 3500
    })
  else
    if not window.clinicFlux.isPlaying()
      window.clinicFlux.start()
      slideFlg = true

  setTimeout(()->
    if $(window).height() + $(this).scrollTop() >= $contentsSlide.offset().top - offset and slideFlg is false
      if not window.clinicFlux.isPlaying()
        window.clinicFlux.start()
        slideFlg = true
  , 500)

  $(window).scroll(()->
    if $(window).height() + $(this).scrollTop() >= $contentsSlide.offset().top - offset
      if slideFlg is false and not window.clinicFlux.isPlaying()
        window.clinicFlux.start()
        slideFlg = true
    else
      if slideFlg is true and window.clinicFlux.isPlaying()
        window.clinicFlux.stop()
        slideFlg = false
  )

if window.matchMedia('(max-width:750px)').matches
  firstView = 'SP'
else
  # PC
  firstView = 'PC'

  clinicSlide()

$(window).on('resize',
  ()->
    if window.matchMedia('(max-width:750px)').matches
      if firstView is 'PC' and resizeFlg.sp is true or
      firstView is false and resizeFlg.sp is true
      # PC から SP へ

        if window.clinicFlux.isPlaying()
          window.clinicFlux.stop()
          slideFlg = false

        resizeFlg.pc = true
        resizeFlg.sp = false
        firstView = false
    else
      if firstView is 'SP' and resizeFlg.pc is true or
      firstView is false and resizeFlg.pc is true
      # SP から PC へ

        clinicSlide()

        resizeFlg.pc = false
        resizeFlg.sp = true
        firstView = false
)
